var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { CurrentMemberKeyFactory, OrganizationInvitationsKeyFactory, } from '../../query-key-factories';
export const useCreateOrganizationInvitation = (workspaceId) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: () => lucidSdk
            .workspaceClient(workspaceId)
            .invitationManagement()
            .createOrganizationInvitation(),
        networkMode: 'always',
        onSuccess: async () => {
            await Promise.all([
                // Update current organization invitation
                queryClient.refetchQueries({
                    exact: true,
                    queryKey: OrganizationInvitationsKeyFactory.byWorkspace(workspaceId),
                }),
                // Update current workspace member
                queryClient.refetchQueries({
                    exact: true,
                    queryKey: CurrentMemberKeyFactory.byWorkspace(workspaceId),
                }),
            ]);
        },
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useCreateOrganizationInvitation, "s074ag8lSG2K0z8InO7Yl75Raxc=", false, () => [useLucidSdk, useQueryClient, useMutation]);
